import * as types from "./mutation-types";

const mutations = {
  [types.SET_PROGRAM_NOTICES](state, notices) {
    state.programNotices = notices;
  },

  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ORGANIZATION_NOTICE](state, notice) {
    state.organizationNotice = notice;
  }
};

export default mutations;
